// extracted by mini-css-extract-plugin
export default {"medicalDocuments":"medicalDocuments_medicalDocuments__Qsm1c","cardContent":"medicalDocuments_cardContent__EuyA2","secondaryCta":"medicalDocuments_secondaryCta__vZPsV"};